// Icon mapping for gradient document and collection heroes.

import {
  FileTextIcon,
  HeartHandshakeIcon,
  LibraryBig,
  NewspaperIcon,
  NotebookTabsIcon,
  SparklesIcon,
  type LucideIcon,
} from 'lucide-react';
import type { Collection, Document } from '@airhead-games/shared/content';

const COLLECTION_HERO_ICONS: Partial<Record<string, LucideIcon>> = {
  'collection:blog': NewspaperIcon,
  'collection:features': SparklesIcon,
  'collection:games': LibraryBig,
  'collection:reports': NotebookTabsIcon,
};

export const getCollectionHeroIcon = (
  collection: Collection
): LucideIcon | undefined => COLLECTION_HERO_ICONS[collection.id];

export const getDocumentHeroIcon = (
  document: Document
): LucideIcon | undefined => {
  if (document.id === 'legal:terms') {
    return HeartHandshakeIcon;
  }

  if (document.kind === 'report') {
    return FileTextIcon;
  }

  return undefined;
};
